import { Injectable } from '@angular/core';
import { apiUrl } from '../../config/api-url';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Announcement } from '../../models/common/announcement';
import { PusherService } from '../pusher.service';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {

  public announcements$: Observable<Announcement>;

  private url = apiUrl + '/showroom/announcements';

  private announcementsSubject: Subject<Announcement>;

  constructor(private http: HttpClient, private pusherService: PusherService) { 
    this.boot();
    this.pusherService.fresh$.subscribe(() => this.boot());
  }

  public getAnnouncements(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>(this.url);
  }

  /**
   * Return the id-s of vendors that work with the current showroom.
   */
  public getAvailableVendors(): Observable<number[]> {
    return this.http.get<number[]>(this.url + '/available-vendors');
  }

  public boot(): void {
    this.announcementsSubject = new Subject();
    this.announcements$ = this.announcementsSubject.asObservable();
    const channel = `private-announcements`;
    this.pusherService.socket
      .subscribe(channel)
      .bind(
        'App\\Events\\AnnouncementCreated', 
        (event: {announcement: Announcement}) => {
          this.announcementsSubject.next(event.announcement)
        }
      );
  }

}
